import { render, staticRenderFns } from "./CategoriesAddNew.vue?vue&type=template&id=21590810"
import script from "./CategoriesAddNew.vue?vue&type=script&lang=js"
export * from "./CategoriesAddNew.vue?vue&type=script&lang=js"
import style0 from "./CategoriesAddNew.vue?vue&type=style&index=0&id=21590810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports